import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

/**
 * Use v-search-toggle to control site search overlay's visiblity
 */
export const searchToggle = {
  mounted(el) {
    const siteHeader = document.querySelector('.js-header');
    const siteSearchOverlay = document.querySelector('.js-site-search-overlay');
    const siteSearchToggle = el;

    siteSearchToggle.addEventListener('click', () => {
      const isSearchExpanded = siteHeader.classList.toggle('is-search-expanded');
      siteHeader.classList.toggle('is-search-active');
      siteSearchOverlay.classList.toggle('is-active');

      if (isSearchExpanded) {
        disableBodyScroll(siteSearchOverlay, { reserveScrollBarGap: true });
      } else {
        enableBodyScroll(siteSearchOverlay);
      }

      siteSearchOverlay.dispatchEvent(new CustomEvent('searchstatechange', { detail: { isSearchExpanded } }));
    });

    siteSearchOverlay.addEventListener('searchstatechange', ({ detail }) => {
      siteSearchToggle.ariaExpanded = detail.isSearchExpanded.toString();
    });
  },
};
